import * as types from '../mutation-types'
import { ajaxFun } from '../actions'

// initial state
const state = {
  all: [],
  flag: false,
  time: ''
}

// const compare = (propertyName) => {
//   return function (object1, object2) {
//     var value1 = object1[propertyName]
//     var value2 = object2[propertyName]
//     if (value2 > value1) {
//       return -1
//     } else if (value2 < value1) {
//       return 1
//     } else {
//       return 0
//     }
//   }
// }

// getters
const getters = {
  teacherList: state => state.all
}

const actions = {
  clearTeachers ({ commit }) {
    commit(types.CLEAR_TEACHERS)
  },

  deleteTeacher ({ commit }, teacherId) {
    commit(types.DELETE_TEACHER, teacherId)
  },

  addToTeachers ({ commit }, classModel) {
    commit(types.ADD_TO_TEACHERS, classModel)
  },

  receiveTeachers ({ commit, state }, para) {
    ajaxFun({commit, state}, para, state.flag, state.time, types.RECEIVE_TEACHERS)
  }
}

// mutations
const mutations = {
  [types.RECEIVE_TEACHERS] (state, teachers) {
    state.all = teachers
    state.flag = true
    state.time = new Date().getTime()
  },

  [types.ADD_TO_TEACHERS] (state, teacher) {
    state.all.push(teacher)
  },

  [types.CLEAR_TEACHERS] (state) {
    state.flag = false
  },

  [types.DELETE_TEACHER] (state, teacherId) {
    state.all.splice(state.all.findIndex(item => item.teacherId == teacherId), 1)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/modules/teachers.js